module.exports = __webpack_public_path__ + "img/3.097e11c7.jpg";